import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/store/auth';
import { logout } from '@/api/auth';

export default function UnsupportedRolePage() {
  const navigate = useNavigate();
  const clear = useAuth((s) => s.clear);

  async function onLogout() {
    await logout();
    clear();
    navigate('/login', { replace: true });
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4 text-center">
      <div className="max-w-md">
        <h1 className="text-2xl font-bold">This role isn't supported on web</h1>
        <p className="mt-3 text-grey-500">
          The PartApp web console is available for academy admins and managers. For trainer or
          student roles, please use the mobile app — it has all the features you need.
        </p>
        <div className="mt-6">
          <Button onClick={onLogout}>Log out</Button>
        </div>
      </div>
    </div>
  );
}
